import React from 'react';
import { Tag, Table, Input } from 'antd';
import { SearchOutlined, FilterOutlined } from '@ant-design/icons';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';

function NewServicesTable({
  items,
  current,
  pageSize,
  loading,
  total,
  onChange,
  onRowClick,
}) {
  const columns = [
    {
      title: 'Наименование',
      dataIndex: 'title',
      key: 'title',
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по наименованию"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.title.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Доступен в мобилке',
      dataIndex: 'isPublic',
      key: 'isPublic',
      render: (isPublic) => {
        return (
          <Tag color={isPublic ? 'green' : 'red'}>
            {isPublic ? 'Да' : 'Нет'}
          </Tag>
        );
      },
      filters: [
        {
          text: 'Доступные',
          value: true,
        },
        {
          text: 'Не доступные',
          value: false,
        },
      ],
      onFilter: (value, record) => record?.isPublic === value,
      filterIcon: () => <FilterOutlined />,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '500px' }}
      tableLayout="fixed"
      pagination={{
        current,
        pageSize,
        total,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { NewServicesTable };
